import React, { Fragment, useContext, useState, useEffect } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { AppBar, Toolbar, Slide, useScrollTrigger, List } from '@material-ui/core'
import CssBaseline from '@material-ui/core/CssBaseline'
import Breadcrumb from './Breadcrumb'
import PageTitle from './PageTitle'
import { AuthContext } from '../../context/AuthContext'
import { LayoutContext } from '../../context/LayoutContext'
import { LogoutItem } from './listItems'

const drawerWidth = 250

const useStyles = makeStyles((theme) => ({
  toolbar: {
    color: '#4B4B4B',
    paddingRight: theme.spacing(4),
    marginLeft: theme.spacing(11),
    position: 'relative'
  },
  logoutIcon: {
    paddingLeft: 2
  },
  appBar: {
    backgroundColor: '#fff',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  texts: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexGrow: 1
  }
}))

interface Props {
  children: React.ReactElement;
}

function HideOnScroll ({ children }: Props) {
  const trigger = useScrollTrigger()
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  )
}

export default function MainBar (): JSX.Element {
  const classes = useStyles()
  const { layout } = useContext(LayoutContext)
  const [pathName, setPathName] = useState('/')
  const { auth } = useContext(AuthContext)

  const breadcrumbNameMap: { [key: string]: any } = {
    '/': ['Home'],
    '/monitoramento-diario/detalhe-principal': ['Monitoramento diário', 'Detalhes', 'Principal'],
    '/monitoramento-diario/detalhe-apps': ['Monitoramento diário', 'Detalhes', 'Apps'],
    '/monitoramento-diario/detalhe-cancelados': ['Monitoramento diário', 'Detalhes', 'Cancelados'],
    '/monitoramento-diario/detalhe-resumo': ['Monitoramento diário', 'Detalhes', 'Resumo'],
    '/analise-de-eventos/overview': ['Eventos de integração', 'Overview'],
    '/pedidos/overview': ['Pedidos', 'Overview'],
    '/pedidos/farmacies': ['Pedidos', 'Farmácias'],
    '/pedidos/detailed-pharmacy': ['Pedidos', 'Farmácia', 'Detalhes'],
    '/pedidos/perdas': ['Pedidos', 'Perdas'],
    '/mudanca-de-cesta/overview': ['Mudança de cesta', 'Overview'],
    '/industrias': ['Indústrias'],
    '/produtos': ['Produtos']
  }

  useEffect(() => {
    setPathName(window.location.pathname)
  }, [])

  return (
    <Fragment>
      <CssBaseline />
      <HideOnScroll>
        <AppBar elevation={1} className={clsx(classes.appBar, layout.isMenuOpen && classes.appBarShift)}>
          <Toolbar className={classes.toolbar}>
            <div className={classes.texts}>
              <Breadcrumb steps={breadcrumbNameMap[pathName]} />
              <PageTitle title={`Olá ${auth.name || auth.email || 'Usuário'}`} />
            </div>
          <div className={classes.logoutIcon}>
          <List>
            <LogoutItem />
          </List>
        </div>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
    </Fragment>
  )
}
